var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalTemplate',{staticClass:"generic",attrs:{"trigger":_vm.trigger,"toggle":_vm.close,"title":_vm.title}},[_c('p',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }